
const Dashboard = ()=>{

    return (
    <div class="main-content">
        <div class="page-content">
            <div class="container-fluid">
                <div className="">
                    <div className=' card py-5 rounded-3 px-3 d-flex justify-content-center align-items-center flex-column'>
                    <h4 >Welcome to</h4>
                    <h3 >{"Master Admin"}</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}
export default Dashboard;